import { useMemo } from 'react';
import { toast } from 'react-toastify';
import { createPortal } from 'react-dom';

import { Modal } from '@querodelivery/uni-react';
import styles from './styles.module.scss';

import useAddressModal from '../../hooks/address/useAddressModal';
import useScreenType from '../../hooks/util/useScreenType';
import { GOOGLE_MAPS_EMBED_API_KEY } from '../../_config/env';
import { useAppSelector } from '../../_store/hooks';

function AddressModal() {
  const isMobile = useScreenType('mobile');

  const address = useAppSelector(state => state.layout.address);
  const coordinates = useAppSelector(state => state.layout.coordinates);
  const location = useAppSelector(state => state.layout.location);
  const openedAddressModal = useAppSelector(
    state => state.layout.openedAddressModal,
  );

  const { closeAddressModal } = useAddressModal();

  const enderecoSearch = useMemo(() => {
    if (address) {
      return `${address.logradouro}, ${address.numero}`;
    }

    if (coordinates) {
      return `${coordinates.coordinates[1]},${coordinates.coordinates[0]}`;
    }

    if (location) {
      return `${location.latitude},${location.longitude}`;
    }

    return '';
  }, [address, coordinates, location]);

  const title = address
    ? `${address.logradouro}, ${address.numero}`
    : 'Endereço';

  const src = `https://www.google.com/maps/embed/v1/place?q=${encodeURI(
    enderecoSearch,
  )}&key=${GOOGLE_MAPS_EMBED_API_KEY}`;

  function renderMap() {
    return (
      <div className={styles.map}>
        <iframe
          src={src}
          width="100%"
          id="myiframe"
          frameBorder="0"
          title="mapa"
          style={{ height: isMobile ? '70vh' : '50vh' }}
        />
      </div>
    );
  }

  if (!address && !coordinates && !location) {
    toast.warn('Endereço inválido');
    closeAddressModal();

    return null;
  }

  return createPortal(
    <Modal
      isOpen={openedAddressModal}
      onClose={closeAddressModal}
      title={title}
      width="50%"
    >
      {renderMap()}
    </Modal>,
    document.body,
  );
}

export default AddressModal;
